var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",style:({
    backgroundImage:
      'url(' + require('../../assets/images/1964-M.C.png') + ')'
  })},[_c('div',{staticClass:"w-container hero-container"},[_vm._m(0),_c('div',{staticClass:"years"},[_vm._v(_vm._s(_vm.$t("marinConstantin.header.years")))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"name"},[_vm._v("Marin "),_c('br'),_vm._v("Constantin")])}]

export { render, staticRenderFns }